export var BreakoutCssClassName = {
  BREAKOUT_MARK: 'fabric-editor-breakout-mark',
  BREAKOUT_MARK_DOM: 'fabric-editor-breakout-mark-dom'
};